module.exports = __webpack_public_path__ + "ed9d9f488eea0ae98674379a0f2cf140.svg";